import { render, staticRenderFns } from "./Backstory.vue?vue&type=template&id=06e6b2b7&scoped=true&"
import script from "./Backstory.vue?vue&type=script&lang=js&"
export * from "./Backstory.vue?vue&type=script&lang=js&"
import style0 from "./Backstory.vue?vue&type=style&index=0&id=06e6b2b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06e6b2b7",
  null
  
)

export default component.exports